import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, BasicApiResponseModel, ApiVisa} from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BundleStockAvailabilityService extends BaseApiTemplateService<number> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + 'bundles/stock-availability';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + 'bundles/stock-availability';
    this.httpClient = http;
  }

  public getBundleStockAvailabilityByGuid(
    bundleFiItemHdrGuid: string, storeGuid: string, visa: ApiVisa
  ): Observable<BasicApiResponseModel<number>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/' + bundleFiItemHdrGuid + '?storeGuid=' + storeGuid;
    return this.httpClient.get<BasicApiResponseModel<number>>
      (Url, this.getHttpHeader(visa));
  }
}
